module.exports = __webpack_public_path__ + "static/media/3.0acd5ce1.jpg";